import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=35e7cce3&"
import script from "./BusinessCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports